import {FileCategoryId, type DirectoryInsight, type Fond, type Rec, type RecordHolding} from 'src/typings';
import type {DirectoryDataService} from 'shared/data-services';
import type {ReloaderService, WalkerService} from 'shared/services';
import {DatasourceGroup, Kind, SearchType, Subkind} from 'shared/constants';
import type {AuthorityHierarchyTree} from './types';
import type {RecordEditationDataService} from '../../record-editation/services/record-editation.data-service';
import type RecordService from '../record.service';

export class KpAuthorityDetailPageService {
    public static serviceName = 'kpAuthorityDetailPageService';

    /*@ngInject*/
    constructor(private recordService: RecordService,
                private directoryDataService: DirectoryDataService,
                private recordEditationDataService: RecordEditationDataService,
                private walker: WalkerService,
                private reloader: ReloaderService) {
    }

    public async getRecordHierarchyTrees(record: Rec): Promise<AuthorityHierarchyTree[]> {
        return this.recordService.getRecordHierarchyTrees(record);
    }

    public async getRecordHoldings(record: Rec): Promise<RecordHolding[]> {
        return this.recordService.getAllRecordHoldings(record);
    }

    public async getDirectoryInsight(record: Rec): Promise<DirectoryInsight | null> {
        if (!record.directoryId) {
            return null;
        }

        return this.directoryDataService.getInsight(record.directoryId, [], [FileCategoryId.COVER])
    }

    public refreshPage(): void {
        this.reloader.reloadPage();
    }

    public async copyRecord(record: Rec) {
        await this.recordService.copyRecordToSpecifiedFondAndAddRecordHoldingThrowingToModal(record);
    }

    public async deleteRecordHolding(recordHolding: RecordHolding, recordHoldings: RecordHolding[]): Promise<void> {
        await this.recordService.deleteRecordHolding(recordHolding, recordHoldings.length <= 1);
    }

    public async updateWithExternalRecord(record: Rec) {
        const initialFrontendParams = {
            q: record.name
        };

        const modalModel = {
            staticSearchParams: {
                kind: [Kind.KIND_RECORD],
                subkind: Subkind.SUBKIND_AUTHORITY,
                type: SearchType.TYPE_SEARCH_SELECTION,
                datasourceGroup: DatasourceGroup.EXTERNAL
            },
            initialFrontendParams
        };

        await this.recordService.updateWithExternalRecordAndReloadThrowingToToast(record, modalModel);
    }

    public async createRecordEditation(record: Rec, fond: Fond): Promise<void> {
        const recordEditation = await this.recordEditationDataService.createNewEditation({
            record,
            fond,
            subkind: Subkind.SUBKIND_AUTHORITY
        });

        await this.walker.newSpaPage(`/record-editations/${recordEditation.id}`);
    }
}